import { useQuery } from "@tanstack/react-query";
import { Activity as ActivityIcon } from "lucide-react";
import { fmtTime } from "@/lib/status";
import api from "@/lib/api";

export default function Activity() {
  const { data: logs = [] } = useQuery({
    queryKey: ["logs", "full"],
    queryFn: () => api.getLogs(200),
    refetchInterval: 4000,
  });

  return (
    <div className="p-6 lg:p-8">
      <div className="mb-6">
        <h1 className="font-heading text-3xl font-extrabold tracking-tight">Aktivite Günlüğü</h1>
        <p className="text-sm text-zinc-500 mt-1">Otomasyon motorunun tüm işlemleri</p>
      </div>

      <div className="border border-zinc-800 bg-zinc-950/60 rounded-md">
        <div className="px-4 py-3 border-b border-zinc-800 flex items-center gap-2">
          <ActivityIcon className="h-4 w-4 text-blue-400" />
          <span className="text-[10px] uppercase tracking-[0.2em] text-zinc-400">Terminal</span>
        </div>
        <div className="p-3 font-mono text-xs max-h-[75vh] overflow-y-auto" data-testid="activity-log">
          {logs.length === 0 ? (
            <div className="text-zinc-600 p-4">Henüz kayıt yok.</div>
          ) : (
            logs.map((l, i) => (
              <div key={i} className="flex gap-3 px-2 py-1.5 hover:bg-zinc-900/60 rounded">
                <span className="text-zinc-600 shrink-0 w-24">{fmtTime(l.timestamp)}</span>
                <span
                  className={`shrink-0 w-16 uppercase font-semibold ${
                    l.level === "success" ? "text-emerald-400"
                      : l.level === "error" ? "text-red-400" : "text-blue-400"
                  }`}
                >
                  {l.level}
                </span>
                {l.code ? <span className="text-zinc-500 shrink-0 w-20">{l.code}</span> : <span className="w-20 shrink-0" />}
                <span className="text-zinc-300">{l.message}</span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
